import { render, staticRenderFns } from "./vendor-rating.vue?vue&type=template&id=2869b828&"
import script from "./vendor-rating.vue?vue&type=script&lang=js&"
export * from "./vendor-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports